import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';

import { Observable } from 'rxjs';
import { UserRegionalService } from '../../user/user-regional.service';
import { RegionalModel } from '../../models/regional.model';

@Injectable({ providedIn: 'root' })
export class AuthRegionalGuard implements CanActivate {
  constructor(
    private userRegionalService: UserRegionalService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    if (
      !this.userRegionalService.isLogged() ||
      this.userRegionalService.isTokenExpired() ||
      !this.userRegionalService.hasRole('ROLE_REGIONAL')
    ) {
      this.router.navigate(['/auth-regional/login'], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }

    return true;
  }
}
